// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-payments-container {
  margin-left: 3.75rem;
}
.billings-header {
  height: 65px;
  align-items: center;
}
.payments-table-content {
  width: 92vw;
  overflow: hidden;
}
.transaction-header {
  margin-bottom: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.transaction-label {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0%;
  color: #0a0f0d;
}

.filter-payments {
  margin-right: 0.5rem;
}
.action-inputs {
  display: flex;
  gap: 0.5rem;
  justify-content: end;
}

.search-payments .ant-input-prefix {
  margin-right: 1rem;
}

.search-payments {
  font-family: Roboto;
  width: 19vw;
}
.filter-payments,
.search-payments,
.payment-search-btn {
  font-family: Roboto;
  /* height: 3.125rem; */
}
.payment-search-btn {
  font-family: Roboto;
  color: #fff !important;
  background: #d2042d !important;
  border: none !important;
}

.payments-download-a {
  color: #d2042d;
  display: flex;
  gap: 0.6rem;
  align-items: center;
}
.payment-ellipsis-btn {
  height: 35px;
  width: 25px;
  border: none;
}
.payment-ellipsis-btn:hover,
.active-ellipsis {
  background: #f5f5f5 !important;
}
.payment-action-items
  .ant-menu-light
  .ant-menu-item:not(.ant-menu-item-selected):not(
    .ant-menu-submenu-selected
  ):hover {
  color: #fff;
  display: flex;
  align-items: center;
}

.payment-action-items
  .ant-menu-light:not(.ant-menu-horizontal)
  .ant-menu-item:not(.ant-menu-item-selected):hover,
.payment-action-items .ant-menu-item-selected {
  background-color: #d2042d !important;
  color: #fff !important;
  display: flex;
  align-items: center;
}
.payment-action-items .action-icons {
  color: #000;
  width: 19px;
  /* height: 25px; */
  margin-right: 0.2rem;
}
.quote-icon svg {
  font-size: 2rem;
}
.billing-payments-container
  .ant-menu-item:not(.ant-menu-item-selected):hover
  .action-icons {
  color: #fff;
}

.buyer-payments-table{
  max-height: 59vh;
  overflow-y: auto;
  padding-right: 1rem;
}

.buyer-payments-table .ant-table-row {
  cursor: pointer;
}
.buyer-payments-table .ant-table-thead > tr > th {
  text-align: left !important;
}
.dashboard-payments-section {
  width: 96vw;
  padding-bottom: 2rem;
}
.process-fee-header {
  font-weight: normal;
  font-size: 13px;
}
@media (max-width: 769px) {
  .billing-payments-container {
    margin-left: 1rem;
  }
  .billing-payments-container input {
    width: 60vw;
  }
  .payments-section {
    overflow-x: scroll;
  }
  .payment-search-btn {
    margin-left: 0.5rem;
    bottom: -0.5rem;
  }
  .buyer-payment-card {
    margin-top: 1.125rem;
    width: 92vw;
  }
  .search-payments {
    width: 70%;
  }
  .payment-label,
  .payment-value {
    font-size: 1rem;
  }
  .payment-label {
    color: #8e9190;
  }
  .payment-value {
    color: #0a0f0d;
    font-weight: 400;
  }
  .invoice-download {
    padding: 1.56rem 0.75rem;
    background: #d2042d !important;
    color: #fff !important;
    width: 80vw;
  }
  .no-records-card {
    margin-top: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments/Payments.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;;;EAGE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;;EAEE,8BAA8B;AAChC;AACA;;;;;EAKE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,oCAAoC;EACpC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;;IAEE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".billing-payments-container {\n  margin-left: 3.75rem;\n}\n.billings-header {\n  height: 65px;\n  align-items: center;\n}\n.payments-table-content {\n  width: 92vw;\n  overflow: hidden;\n}\n.transaction-header {\n  margin-bottom: 26px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.transaction-label {\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: 0%;\n  color: #0a0f0d;\n}\n\n.filter-payments {\n  margin-right: 0.5rem;\n}\n.action-inputs {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: end;\n}\n\n.search-payments .ant-input-prefix {\n  margin-right: 1rem;\n}\n\n.search-payments {\n  font-family: Roboto;\n  width: 19vw;\n}\n.filter-payments,\n.search-payments,\n.payment-search-btn {\n  font-family: Roboto;\n  /* height: 3.125rem; */\n}\n.payment-search-btn {\n  font-family: Roboto;\n  color: #fff !important;\n  background: #d2042d !important;\n  border: none !important;\n}\n\n.payments-download-a {\n  color: #d2042d;\n  display: flex;\n  gap: 0.6rem;\n  align-items: center;\n}\n.payment-ellipsis-btn {\n  height: 35px;\n  width: 25px;\n  border: none;\n}\n.payment-ellipsis-btn:hover,\n.active-ellipsis {\n  background: #f5f5f5 !important;\n}\n.payment-action-items\n  .ant-menu-light\n  .ant-menu-item:not(.ant-menu-item-selected):not(\n    .ant-menu-submenu-selected\n  ):hover {\n  color: #fff;\n  display: flex;\n  align-items: center;\n}\n\n.payment-action-items\n  .ant-menu-light:not(.ant-menu-horizontal)\n  .ant-menu-item:not(.ant-menu-item-selected):hover,\n.payment-action-items .ant-menu-item-selected {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  display: flex;\n  align-items: center;\n}\n.payment-action-items .action-icons {\n  color: #000;\n  width: 19px;\n  /* height: 25px; */\n  margin-right: 0.2rem;\n}\n.quote-icon svg {\n  font-size: 2rem;\n}\n.billing-payments-container\n  .ant-menu-item:not(.ant-menu-item-selected):hover\n  .action-icons {\n  color: #fff;\n}\n\n.buyer-payments-table{\n  max-height: 59vh;\n  overflow-y: auto;\n  padding-right: 1rem;\n}\n\n.buyer-payments-table .ant-table-row {\n  cursor: pointer;\n}\n.buyer-payments-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n.dashboard-payments-section {\n  width: 96vw;\n  padding-bottom: 2rem;\n}\n.process-fee-header {\n  font-weight: normal;\n  font-size: 13px;\n}\n@media (max-width: 769px) {\n  .billing-payments-container {\n    margin-left: 1rem;\n  }\n  .billing-payments-container input {\n    width: 60vw;\n  }\n  .payments-section {\n    overflow-x: scroll;\n  }\n  .payment-search-btn {\n    margin-left: 0.5rem;\n    bottom: -0.5rem;\n  }\n  .buyer-payment-card {\n    margin-top: 1.125rem;\n    width: 92vw;\n  }\n  .search-payments {\n    width: 70%;\n  }\n  .payment-label,\n  .payment-value {\n    font-size: 1rem;\n  }\n  .payment-label {\n    color: #8e9190;\n  }\n  .payment-value {\n    color: #0a0f0d;\n    font-weight: 400;\n  }\n  .invoice-download {\n    padding: 1.56rem 0.75rem;\n    background: #d2042d !important;\n    color: #fff !important;\n    width: 80vw;\n  }\n  .no-records-card {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
